import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

import iframe from '../../dashboard-routes/Iframe/iframeData';
import CaseProgress from '../../shared/CaseProgress';
import Modal from '../../shared/Modal';
import Store from './clinicalNoteStore';
import * as api from '../../../stores/api';

function ModalCaseProgress() {
  const openCaseCorrespondence = () => {
    const {
      toggleModal,
      modalParams: { id },
    } = Store;

    const caseNo = `Case F-${(id + '').padStart(6, 0)}`;
    localStorage.setItem('FileReviewCaseId', caseNo);
    iframe.forceOpenTab('PostFileReview', `?id=${id}&view=PostFileReview#Corespondence`, {
      id,
      view: 'PostFileReview',
    });

    toggleModal(false)();
  };

  const { open, modalParams, toggleModal } = Store;
  const title = `Case Progress: ${modalParams.caseNo}`;
  const url = '/FileReview/GetFileReviewLogs';
  const body = { fileReviewId: modalParams.id };

  return (
    <Modal
      visible={open}
      onCancel={toggleModal(false)}
      width={1250}
      title={title}
      footer={
        <React.Fragment>
          {!api.isTypist() && (
            <Button color="blue" onClick={openCaseCorrespondence}>
              <Icon name="table" /> View Case Correspondence
            </Button>
          )}
          <Button color="red" onClick={toggleModal(false)}>
            <Icon name="close" /> Close
          </Button>
        </React.Fragment>
      }
    >
      <CaseProgress progressList={api.FR_CaseProgress.data.itemList} url={url} body={body} showHistory />
    </Modal>
  );
}

export default ModalCaseProgress;
